// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ph-9";
export var arrowButtonContainer = "_ph-5";
export var arrowButtonIcon = "_ph-6";
export var carouselArrowButton = "_ph-2";
export var carouselElementContainer = "_ph-1";
export var currentSlide = "_ph-8";
export var left = "_ph-3";
export var otherSlide = "_ph-a";
export var productCarouselContainer = "_ph-0";
export var right = "_ph-4";
export var sliderOverflow = "_ph-7";